import e from "@dialpad/dialtone-tokens/layered/themes/tokens-verdant-haze-colors.css?inline";
//#region themes/verdant-haze.js
var t = { brand: {
	css: e,
	name: "verdant-haze"
} };
//#endregion
export { t as default };
